import { css } from '@emotion/react';
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded';
import { GREEN_COLOR, RED_COLOR } from '../styles/colors';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ALL_TOAST_TYPES = [
    'direct-message',
    'side-bet-won',
    'side-bet-lost',
    'side-bet-refunded',
    'side-bet-error',
    'change-email-error',
    'change-password-error'
];
function createToastThemeStyle({ backgroundColor, textColor, borderColor, iconColor }) {
    return css `
    & .MuiSnackbarContent-root {
      background-color: ${backgroundColor};
      color: ${textColor};
      border: 1px solid ${borderColor};
      border-radius: 10px;
      filter: drop-shadow(4px 4px 0 rgba(0, 0, 0, 0.4));
    }
    .MuiIconButton-root {
      color: ${iconColor};
    }
  `;
}
const DEFAULT_STYLE = createToastThemeStyle({
    backgroundColor: 'white',
    textColor: 'black',
    borderColor: '#888',
    iconColor: 'black'
});
const RED_STYLE = createToastThemeStyle({
    backgroundColor: RED_COLOR,
    textColor: 'black',
    borderColor: RED_COLOR,
    iconColor: 'black'
});
export const ALL_TOAST_TYPE_PROPERTIES = {
    'direct-message': {
        style: DEFAULT_STYLE
    },
    'side-bet-won': {
        svgIconComponent: CasinoRoundedIcon,
        autoHideDuration: 5000,
        style: createToastThemeStyle({
            backgroundColor: GREEN_COLOR,
            textColor: 'black',
            borderColor: GREEN_COLOR,
            iconColor: 'black'
        })
    },
    'side-bet-lost': {
        svgIconComponent: CasinoRoundedIcon,
        autoHideDuration: 5000,
        style: RED_STYLE
    },
    'side-bet-refunded': {
        svgIconComponent: CasinoRoundedIcon,
        autoHideDuration: 5000,
        style: createToastThemeStyle({ backgroundColor: '#AAA', textColor: '#444', borderColor: '#444', iconColor: '#444' })
    },
    'side-bet-error': {
        svgIconComponent: CasinoRoundedIcon,
        autoHideDuration: 5000,
        style: createToastThemeStyle({ backgroundColor: '#AAA', textColor: '#444', borderColor: '#444', iconColor: '#444' })
    },
    'change-email-error': {
        style: RED_STYLE
    },
    'change-password-error': {
        style: RED_STYLE
    }
};
export function getDirectMessageToastKey(playerId) {
    return `direct-message-${playerId}`;
}
export const CHANGE_PASSWORD_TOAST_KEY = 'change-password';
export const CHANGE_EMAIL_TOAST_KEY = 'change-email';
